import { useHistory, useParams, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useStyles } from 'components/Styles';
import Success from 'components/Snack/Success';
import Error from 'components/Snack/Error';
import { setDisable } from 'redux/disable';
import { setLoading } from 'redux/loading';
import api from 'services/api';

export function useDependencyInjection() {
  const classes = useStyles();
  const error = Error();
  const success = Success();
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const { id } = useParams();
  const disable = useSelector((state) => state.disable.disable);

  const loadingRequest = () => {
    dispatch(setDisable(true));
    dispatch(setLoading(true));
  };

  const requestCompleted = () => {
    dispatch(setDisable(false));
    dispatch(setLoading(false));
  };

  return {
    classes,
    error,
    success,
    history,
    dispatch,
    id,
    disable,
    loadingRequest,
    requestCompleted,
    location,
    api,
  };
}
